export default {
    card: {
        title: 'Replies to comments',
        description:
            'Choose whether the people who read the results can reply to the comments of respondents to learn more.',
        fixedDescription:
            'Shows whether the people who read the results can reply to the comments of respondents to learn more.',
        enabled: {
            title: 'Enabled',
            managersReply:
                'The people who read the results, {{managerPluralLabel}} included, can reply to comments to ask a question or for an example.',
        },
        disabled: {
            title: 'Disabled',
            noReply:
                'No one can reply to comments: neither {{managerPluralLabel}} nor respondents.',
        },
        completedNotice: 'This 360 feedback is over: this setting can no longer be changed.',
    },
    pill: 'Replies disabled',
    pillExplanation:
        'No one can reply to comments. Comments left under the questions and conversations already started stay readable.',
    repliesClosedRefused:
        'Replies to comments have just been disabled for this 360 feedback: your reply was not sent.',
};
